"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePromotionSchema = exports.createPromotionSchema = exports.PROMOTION_TYPES = void 0;
const zod_1 = require("zod");
exports.PROMOTION_TYPES = ['PERCENTAGE_OFF', 'FIXED_AMOUNT_OFF', 'FIXED_PRICE'];
exports.createPromotionSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(255),
    promotionType: zod_1.z.enum(exports.PROMOTION_TYPES),
    promotionValue: zod_1.z.number().nonnegative(),
    drugId: zod_1.z.string().uuid().optional(),
    itemId: zod_1.z.string().uuid().optional(),
    priceListId: zod_1.z.string().uuid().optional(),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().optional(),
    priority: zod_1.z.number().int().optional(),
    remarks: zod_1.z.string().optional(),
});
exports.resolvePromotionSchema = zod_1.z.object({
    basePrice: zod_1.z.coerce.number().int().nonnegative(),
    drugId: zod_1.z.string().uuid().optional(),
    itemId: zod_1.z.string().uuid().optional(),
    priceListId: zod_1.z.string().uuid().optional(),
    asOfDate: zod_1.z.coerce.date().optional(),
});
//# sourceMappingURL=promotion.schema.js.map